var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-unit-items",
    },
    [
      !_vm.inCourseContext && _vm.hasUnits
        ? _c("h2", [
            _vm._v(_vm._s(_vm.$gettext("Persönliche Lernmaterialien"))),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasUnits
        ? _c(
            "ul",
            {
              staticClass: "cw-tiles",
            },
            _vm._l(_vm.units, function (unit) {
              return _c("courseware-unit-item", {
                key: unit.id,
                attrs: {
                  unit: unit,
                },
              })
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.hasUnits && _vm.inCourseContext
        ? [
            _vm.userIsTeacher
              ? _c(
                  "div",
                  {
                    staticClass: "cw-contents-overview-teaser",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "cw-contents-overview-teaser-content",
                      },
                      [
                        _c("header", [
                          _vm._v(_vm._s(_vm.$gettext("Lernmaterialien"))),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.$gettext(
                                  "Mit Courseware können Sie interaktive, multimediale Lerninhalte erstellen und nutzen. " +
                                    "Die Lerninhalte lassen sich hierarchisch unterteilen und können aus Texten, Videosequenzen, " +
                                    "Aufgaben, Kommunikationselementen und einer Vielzahl weiterer Elemente bestehen. " +
                                    "Fertige Lerninhalte können exportiert und in andere Kurse oder andere Installationen importiert werden. " +
                                    "Courseware ist nicht nur für digitale Formate geeignet, sondern kann auch genutzt werden, " +
                                    "um klassische Präsenzveranstaltungen mit Online-Anteilen zu ergänzen. Formate wie integriertes Lernen " +
                                    "(Blended Learning) lassen sich mit Courseware ideal umsetzen. Kollaboratives Lernen kann dank Schreibrechtevergabe " +
                                    "und dem Einsatz von Courseware in Studiengruppen realisiert werden."
                                )
                              ) +
                              "\n                "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "button",
                            on: {
                              click: function click($event) {
                                return _vm.setShowUnitAddDialog(true)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(
                                  _vm.$gettext("Neues Lernmaterial anlegen")
                                ) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                )
              : _c("courseware-companion-box", {
                  attrs: {
                    msgCompanion: _vm.$gettext(
                      "Es wurden leider noch keine Lernmaterialien angelegt."
                    ),
                    mood: "sad",
                  },
                }),
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.hasUnits && !_vm.inCourseContext
        ? _c(
            "div",
            {
              staticClass: "cw-contents-overview-teaser",
            },
            [
              _c(
                "div",
                {
                  staticClass: "cw-contents-overview-teaser-content",
                },
                [
                  _c("header", [
                    _vm._v(
                      _vm._s(_vm.$gettext("Ihre persönlichen Lernmaterialien"))
                    ),
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(
                        _vm.$gettext(
                          "Erstellen und verwalten Sie hier Ihre eigenen persönlichen Lernmaterialien in Form von ePorfolios, " +
                            "Vorlagen für Veranstaltungen oder einfach nur persönliche Inhalte für das Studium. " +
                            "Entwickeln Sie Ihre eigenen (Lehr-)Materialien für Studium oder die Lehre und teilen diese mit anderen Nutzenden."
                        )
                      )
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button",
                      on: {
                        click: function click($event) {
                          return _vm.setShowUnitAddDialog(true)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$gettext("Neues Lernmaterial anlegen")) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }